import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { SENDBIRD_NOTIFICATION_CLICK } from "utils/chatNotificationEvents";

export { SENDBIRD_NOTIFICATION_CLICK };

/**
 * Navigates to the conversation when the user clicks a web push while the
 * app is already open in another tab.
 */
const useNotificationClickNavigation = () => {
  const history = useHistory();

  useEffect(() => {
    const navigateTo = (path) => {
      if (typeof path !== "string" || !path.startsWith("/")) return;
      history.push(path);
    };

    const onMessage = (event) => {
      const data = event?.data;
      if (!data || data.type !== SENDBIRD_NOTIFICATION_CLICK) return;
      navigateTo(data.path);
    };

    const onWindowNotificationClick = (event) => {
      navigateTo(event?.detail?.path);
    };

    window.addEventListener(SENDBIRD_NOTIFICATION_CLICK, onWindowNotificationClick);
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", onMessage);
    }

    return () => {
      window.removeEventListener(
        SENDBIRD_NOTIFICATION_CLICK,
        onWindowNotificationClick
      );
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", onMessage);
      }
    };
  }, [history]);
};

export default useNotificationClickNavigation;
